import { create } from 'zustand'
import { HelperState } from './HelperState'
import { HelperConfig } from './Helpers'

export const useHelperStore = create<HelperState>()(
  (setter) => new HelperState(setter)
)
export function useHasOpenHelpers(){
    const hasOpenHelpers:boolean = useHelperStore((state:HelperState)=>{
      const isOpen = (helper:HelperConfig)=>{
        return helper.displayOrder !== 0
      }
      return state.helpers.some(isOpen)
    }) 
    return hasOpenHelpers
}
export function useGetAllHelpers(){
    const helpers:HelperConfig[] = useHelperStore((state:HelperState)=>{
      return state.helpers
    }) 
    return helpers
}
export function useGetHelperDisplayOrder(){
    const helpers:HelperConfig[] = useHelperStore((state:HelperState)=>{
      return state.helpers
    }) 
    const helperIndexes:number[][] = []
    helpers.forEach((helper:HelperConfig, index:number)=>{
        if(helper.displayOrder != 0){
            helperIndexes.push([index, helper.displayOrder])
        }
    })
    helperIndexes.sort((a:number[], b:number[])=>{return(a[1]-b[1])})
    return helperIndexes
}